// Module
var code = "<div class=\"node\"> <a href=\"/form/{{ $ctrl.kid }}\" target=\"_blank\">{{ $ctrl.name }}</a> </div> ";
// Exports
export default code;